import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { header } from "../globalVariables";
import { api, cleanJSON, isJSON, robustJsonParse } from "../pureFunctions";
import { formatText } from "../formatFunctions";
import LoadingAnimation from "../LoadingAnimation";

import questionIcon from "../img/questionmark.png";

export function AiHelper({ allKacheln, basicdata }) {
   const [loading, setLoading] = useState("");
   const [aiResponse, setAiResponse] = useState("");
   const [show, setShow] = useState(false);
   const [prompt, setPrompt] = useState("");

   async function genFilter() {
      setLoading(true);
      console.log(allKacheln);

      const onlyNames = Object.values(allKacheln).map((item) => {
         return {
            stufenId: item.id,
            stufenHeading: item.heading,
            filter: item.filter,
            kachel: item.kachel.map((kachelItem) => {
               return {
                  kachelHeading: kachelItem.heading,
                  kachelId: kachelItem.kachelId,
                  filter: kachelItem.filter,
                  fields: kachelItem.fields.flat().map((fieldItem) => {
                     return {
                        fieldHeading: fieldItem.heading??fieldItem.buttonName,
                        fieldId: fieldItem.name,
                        type: fieldItem.type,
                        ...(fieldItem.optional ? { optional: fieldItem.optional } : {}),
                        ...(fieldItem.options ? { options: fieldItem.options } : {}),
                        ...(fieldItem.filter ? { filter: fieldItem.filter } : {}),
                     };
                  }),
               };
            }),
         };
      });

      const content = await api
         .post(
            `api/ai_prompt`,
            {
               // model: "sonnet-5-5",
               // model: "mistral-medium",
               model: "ministral-14b",
               messages: [
                  {
                     role: "system",
                     content: systemPrompt
                        .replace("$ALLKACHELN", JSON.stringify(onlyNames))
                        .replace("$ALLDATA", JSON.stringify(basicdata)),
                  },
                  { role: "user", content: prompt },
               ],
               // outputConfig: outputConfig,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            console.log(data?.data?.content);

            return data?.data?.content ?? data?.content;
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
         });
      setLoading(false);
      setAiResponse(content);
   }

   const handleClose = () => {
      setShow(false);
   };

   const handleShow = () => {
      setShow(true);
   };
   return (
      <>
         <div style={{ position: "relative" }}>
            <button
               onClick={() => {
                  handleShow();
               }}
               className="custom-button"
               style={{
                  position: "absolute",
                  width: "56px",
                  right: "360px",
                  zIndex: 0,
               }}
               title="Frage"
            >
               <img src={questionIcon} />
            </button>
         </div>
         <Modal show={show} size="xl" onHide={handleClose} dialogClassName="mt-5">
            <Modal.Header closeButton>{/* <Modal.Title>Frage</Modal.Title> */}</Modal.Header>
            <Modal.Body>
               <Alert>
                  Hier können allgmein Fragen zu den Kacheln und Felder gestellt werden. <br />
                  z.B.
                  <ul>
                     <li>Warum wird der Teamsbutton in der Kachel "Übergabe Einkauf an Haus" nicht angezeigt?</li>
                     <li>Bis wann gilt die Brandversicherung </li>
                  </ul>
                  Es können hier keine sonstigen Fragen zum Immopiloten oder sonst was beantwort werden.
               </Alert>
               <Row>
                  <Col>
                     <Form.Group className="mb-3" controlId="prompt">
                        <Form.Label>Frage</Form.Label>
                        <Form.Control
                           autoComplete="off"
                           placeholder="..."
                           style={{ minHeight: "120px", fieldSizing: "content" }}
                           as="textarea"
                           onChange={(e) => {
                              setPrompt(e.target.value);
                           }}
                           value={prompt}
                        />
                     </Form.Group>
                  </Col>
               </Row>
               {aiResponse && (
                  <div className="my-2 p-2">
                     <p
                        style={{
                           border: "dotted 1px #bbb",
                           padding: "10px 20px",
                           borderRadius: "10px",
                           whiteSpace: "pre-line",
                           margin: 0,
                        }}
                     >
                        {formatText(aiResponse)}
                     </p>
                     <small>
                        Die Antwort kann Fehler enthalten!
                        <br />
                        Wenn die Antwort falsch ist, ggf. die Frage genauer oder anders stellen. Und ansonsten bitte
                        eine Nachricht mit Screenshot an Jonathan.{" "}
                     </small>
                  </div>
               )}

               <div className="d-flex justify-content-end w-100">
                  <Button
                     className="w-100"
                     variant="dark"
                     onClick={() => {
                        genFilter();
                     }}
                  >
                     {loading ? <LoadingAnimation /> : "Frage stellen"}
                  </Button>
               </div>
            </Modal.Body>
         </Modal>
      </>
   );
}

const systemPrompt = `

Ich habe dieses Objekt mit Stufen, Kacheln und Feldern.

<struktur>$ALLKACHELN</struktur>
Die Projektstufen werden von oben nach unten bearbeitet. Gestartet wird mit dem Datenblatt.
Folgende Funktion wird verwendet um zu berechnen, wann Projektstufen, Kacheln und Felder angezeigt werden.
Wenn eine Projektstufe nicht angezeigt wird, werden auch die darin liegenden Kacheln nicht angezeigt.
Wenn eine Kachel nicht angezeigt wird, werden auch die darin liegenden Felder nicht angezeigt.
Wenn kein filter angegeben ist, wird die Kachel bzw. das Feld angezeigt, wenn die übergeordnete Projektstufe bzw. die übergeordnete Kachel angezeigt wird.

function evaluateRule(item, rule) {
   // Falls es eine Untergruppe ist (OR / AND)
   if (!rule || Object.keys(rule).length === 0) {
      return true;
   }

   if (rule.logic) {
      if (rule.logic === "and") {
         return rule.rules.every((subRule) => evaluateRule(item, subRule));
      }
      if (rule.logic === "or") {
         return rule.rules.some((subRule) => evaluateRule(item, subRule));
      }
   }

   // Die eigentliche Feld-Prüfung (Logik-Zentrum)
   const value = item[rule.field];

   switch (rule.op) {
      case "===":
         return value === rule.value;
      case "!==":
         return value !== rule.value;
      case "<=":
         return value <= rule.value;
      case ">=":
         return value >= rule.value;
      case "<":
         return value < rule.value;
      case ">":
         return value > rule.value;
      case "hasValue":
         return value !== undefined && value !== null && value !== "";
      case "valid":
         return value !== undefined && value !== null;
      case "afterDays": //Anzeigen, wenn der Feldwert neuer ist als in dem Filter angegeben in Tagen von jetzt
            return new Date(value).getTime() > Date.now() + rule.value * 24 * 60 * 60 * 1000;
         case "beforeDays": //Anzeigen, wenn der Feldwert älter ist als in dem Filter angegeben in Tagen von jetzt
            return new Date(value).getTime() < Date.now() - rule.value * 24 * 60 * 60 * 1000;

      case "has_image":
         return item.images && item.images.length > 0;
      default:
         return true;
   }
}

Nutze folgende informationen falls notwendig für die formulierung der antwort:

Falls es um den um die Statuswert von Projektstufen oder Kacheln geht, wie bei projekt_status_ + stufenId oder kachel_status_ + kachelId:
- 4 bedeutet "abgeschlossen"
- unter 9 (außer 4): "nicht abgeschlossen"
- 9 oder höher: "entfernt bzw. deaktiviert"
Nenne nie den Zahlenwert.

Kacheln können abgeschlossen werden, wenn alle Felder, die nicht optional sind ausgefüllt sind.
Nenne immer den Wert der Heading als Bezeichnung für die Felder, Kacheln und Projektstufen. 
Nenne ggf. die dazugehörige Kachel und Projektstufe.
Gib weder den Code noch die Filterregeln aus in der Antwort aus.
Gib auf keinen Fall personenbezogene Daten aus.

Nutze zum Hervorheben von Textabschnitten umschließende **Doppelsternchen** oder __Doppelunterstriche__ aber niemals beides.

Hier sind die vorhandenen Daten:

<daten>$ALLDATA</daten>

Überprüfe vor der Ausgabe, ob die Frage und Antwort sinnvoll zu den Daten gehören. Falls nicht, fordere den Nutzer auf die Frage zu konkretisieren.
Wenn nach etwas gefragt wird, was es nicht gibt, frage nochmal beim Nutzer nach.

Beschränke dich auf die zwingend notwendigen Informationen, erfinde keine Informationen.
Falls du die Frage mit den gegebenen Informationen nicht beantworten kannst, fordere den Nutzer auf die Frage nochmal anzupassen oder verweise auf den Support.
Du sollst Fragen möglichst kurz beantworten mit maximal 60 Wörtern.

`;
